export default ()=>{
	const files=require.context('../../models',false,/\.js$/);
	const models={};
	files.keys().forEach((key)=>{
		models[key.match(/\/(.*)\.(js|tsx)/)[1]]=files(key).default;
	})
	return models;
}